import React, { useRef, useEffect } from 'react';
import { Typography, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
const { Text } = Typography;

const EditableTitle = ({ initialTitle, onTitleChange, isEditing, setIsEditing, chatIdentifier }) => {
  const [title, setTitle] = React.useState(initialTitle);
  const inputRef = useRef(null);
  const history = useHistory();
 
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  
  useEffect(() => {
    setTitle(initialTitle);
  }, [initialTitle]);

  const handleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setIsEditing(false);
      onTitleChange(title);
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setTitle(initialTitle);
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    onTitleChange(title);
  };

  return (
    <div className="editable-title">
      {isEditing ? (
        <input
          ref={inputRef}
          type="text"
          value={title}
          maxLength={150}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          className="title-input w-full bg-gray-100 outline-none border-b border-gray-300 text-black"
          onClick={(e) => e.stopPropagation()} // Prevent menu item click when editing
        />
      ) : (
        <Tooltip placement="right" title={title}> 
         <div style={{
                  display: 'inline-block',
                  maxWidth: '100%'
                }}
         >
          <Text
        onClick={() => {
          history.push(`/chat/${chatIdentifier}`);
        }}
        className="title-display"
        ellipsis={false}
      >{title}</Text>  
      </div>        
        </Tooltip>
      )}
    </div>
  );
};

export default EditableTitle;